/**
 * Tailwind-variants definition for `<SmartStartGridV4>`. Lives in a sibling
 * file (not in `SmartStartGrid.v4.tsx`) so the component file only exports
 * components — required by `react-refresh/only-export-components` for HMR
 * to work without forcing a full reload on style edits.
 */
import { tv, type VariantProps } from 'tailwind-variants';

export const smartStartGridV4Variants = tv({
  base: 'grid grid-cols-2 gap-4',
});

export type SmartStartGridV4VariantProps = VariantProps<typeof smartStartGridV4Variants>;
